export const REQUEST_AUDIO = 'REQUEST_AUDIO'
export const REQUESTED_AUDIO = 'REQUESTED_AUDIO'
export const REQUEST_VIDEO = 'REQUEST_VIDEO'
export const REQUESTED_VIDEO = 'REQUESTED_VIDEO'
export const REQUEST_IMAGE = 'REQUEST_IMAGE'
export const REQUESTED_IMAGE = 'REQUESTED_IMAGE'
export const REQUEST_AJAX = 'REQUEST_AJAX'
export const REQUESTED_AJAX = 'REQUESTED_AJAX'
export const SET_LOCALE = 'SET_LOCALE'
export const REQUEST_CONTENT = 'REQUEST_CONTENT'
export const RECEIVE_CONTENT = 'RECEIVE_CONTENT'
export const REQUESTED_CONTENT = 'REQUESTED_CONTENT'
export const PRELOADED_ASSETS = 'PRELOADED_ASSETS'
